// Helper utility method to fetch the survey config
// In development mode, loads from local file
// In production, fetches from API endpoint
export async function fetchSurveyConfig() {
    // Check if we're in development mode
    if (import.meta.env.DEV) {
        try {
            const config = await import('../../survey-config.json');
            return config.default;
        } catch (error) {
            console.error('Failed to load local survey config:', error);
            throw new Error('Failed to load local survey config');
        }
    } else {
        // In production, fetch from API endpoint
        try {
            const response = await fetch('/api/survey-config');
            if (!response.ok) throw new Error('Failed to load survey config');
            return response.json();
        } catch (error) {
            console.error('Failed to fetch survey config from API:', error);
            throw new Error('Failed to fetch survey config from API');
        }
    }
}
